const outerHTML = elem => elem.outerHTML

const concatHTML = (html, column) =>
  `${html}<div class='column'>\n${column.join('\n')}\n</div>\n`


const toColumns = (elems, numCols = 2) => {
	const elemsArr = Array.from(elems).map(outerHTML);
	const total = elems.length;
	let chunks = Math.ceil(total/numCols);
	let result = [];

	for (let i = 0; i < numCols; i++) {
		result.push(elemsArr.splice(0, chunks));
  	}

	if(elemsArr.length > 0) result.push(elemsArr);

	return result.reduce(concatHTML, '');
}

const renderColumns = () => {
	let columnsCount = 2;

	if(window.innerWidth > 768) { columnsCount = 3;}
	if(window.innerWidth > 1024) { columnsCount = 4;}

	document.querySelectorAll('.partner-list-wrapper').forEach(wrapper => {
		const items =wrapper.querySelectorAll('.partner-list-item');
		wrapper.innerHTML = toColumns(items, columnsCount);
	})
}

document.addEventListener('facetwp-loaded', function() {
	renderColumns();
})

window.addEventListener('resize', function() {
	renderColumns();
})
